export default __webpack_public_path__ + "static/media/bg27.b26d0c6b.jpg";